import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { connect as connectFormik } from 'formik';
import { domainActions } from '../../store/domainStore';
import { unicornAttribute, unicornAttributes, unicornCountry } from "../../store/marketingListStore";
import { Translate, withLocalize } from 'react-localize-redux';
import BbFormikCheckbox from "../styling/bbFormikCheckbox";
import BbInput from '../styling/bbInput';
import MarketingSection from '../marketingList/marketingSection';
import PopupMultiSelectButton from '../common/popupMultiSelectButton';

class ActivityScope extends React.Component {

    render() {
        return (<MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false} section="activity" searchTip={this.props.translate(this.props.searchTip)} errors={this.props.errors}>
            <BbInput type='custom' label='NACE' placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title='NACE'
                    data='nace'
                    name='activity.nace'
                    popupSize='large'
                    onClick={() => this.props.ensureDomainData('nace', { marketAttributes: unicornAttributes() })}
                    selection={this.props.formik.values.activity.nace}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('activity.nace.all', all);
                        this.props.formik.setFieldValue('activity.nace.parent', parent);
                    }}
                    splitOnlyParent={true}
                />
            } />
            {unicornCountry() === "sk" && <BbInput type='radio' label={this.props.translate('Search.ActivityScope.NaceSource')} placeholder={{ type: 'column' }}
                options={this.getOptions()}
                idFormat={(val) => `$radio-activity-naceSource-${val}`}
                checkedValue={this.getValue(this.props.formik.values.activity.naceSource)}
                callback={(val) => this.props.formik.setFieldValue(`activity.naceSource`, val)}
            />}
            <div className='field bb-field'>
                <div className='columns'>
                    <div className='column'>
                        <BbFormikCheckbox label={this.props.translate("Search.ActivityScope.OnlyMainNace")} style={{ paddingLeft: "0" }}
                            name="activity.onlyMainNace" id="onlyMain" />
                    </div>
                </div>
            </div>
            <BbInput type='custom' label={this.props.translate('Search.ActivityScope.InstitutionalSector')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title={this.props.translate('Search.ActivityScope.InstitutionalSector')}
                    data='institutional-sectors'
                    name='activity.institutionalSectors'
                    popupSize='large'
                    onClick={() => this.props.ensureDomainData('institutional-sectors')}
                    selection={this.props.formik.values.activity.institutionalSectors}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('activity.institutionalSectors.all', all);
                        this.props.formik.setFieldValue('activity.institutionalSectors.parent', parent);
                    }}
                    splitOnlyParent={true}
                />
            } />
            {unicornCountry() === "sk" && <BbInput type='custom' label={this.props.translate('Search.ActivityScope.OwnershipTypeSk')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title={this.props.translate('Search.ActivityScope.OwnershipTypeSk')}
                    data='ownership-types'
                    name='activity.ownerships'
                    popupSize='large'
                    onClick={() => this.props.ensureDomainData('ownership-types')}
                    selection={this.props.formik.values.activity.ownerships}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('activity.ownerships.all', all);
                        this.props.formik.setFieldValue('activity.ownerships.parent', parent);
                    }} />
            } />}
            <BbInput type='custom' label={this.props.translate('Search.ActivityScope.Turnover')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title={this.props.translate('Search.ActivityScope.Turnover')}
                    data='turnover-ranges'
                    name='activity.turnovers'
                    onClick={() => this.props.ensureDomainData('turnover-ranges', { marketAttribute: unicornAttribute() })}
                    selection={this.props.formik.values.activity.turnovers}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('activity.turnovers.all', all);
                        this.props.formik.setFieldValue('activity.turnovers.parent', parent);
                        this.setDefaultTurnoverYear(all);

                    }} />
            } />
            <BbInput
                type="custom" label={this.props.translate('Search.ActivityScope.TurnoverYears')} placeholder={{ type: 'column' }}
                custom={
                    <PopupMultiSelectButton
                        title={this.props.translate('Search.ActivityScope.TurnoverYears')}
                        data='turnover-years'
                        name='activity.turnoverYears'
                        onClick={() => this.props.ensureDomainData('turnover-years', { marketAttribute: unicornAttribute() })}
                        selection={this.props.formik.values.activity.turnoverYears}
                        handleChange={(all, parent) => {
                            this.props.formik.setFieldValue('activity.turnoverYears.all', all);
                            this.props.formik.setFieldValue('activity.turnoverYears.parent', parent);
                        }} />
                } />
            <BbInput type='custom' label={this.props.translate('Search.ActivityScope.SizeCategory')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    title={this.props.translate('Search.ActivityScope.SizeCategory')}
                    data='size-categories'
                    name='activity.employeeRanges'
                    onClick={() => this.props.ensureDomainData('size-categories', { marketAttribute: unicornAttribute() })}
                    selection={this.props.formik.values.activity.employeeRanges}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('activity.employeeRanges.all', all);
                        this.props.formik.setFieldValue('activity.employeeRanges.parent', parent);
                    }} />
            } />
            <div className='field bb-field'>
                <div className='columns'>
                    <div className='column is-one-third bb-input-label-column'>
                        <div className="label-wrapper">
                            <span className="marketing-label">  <Translate id='Search.ActivityScope.EmployeesCount' /></span>
                        </div>
                    </div>
                    <div className="is-flex w-100">
                        <div className='column is-one-half bb-input-column'>
                            <BbInput label={this.props.translate("Common.From")} name="activity.minEmployees" type="number" placeholder={{ type: 'inline' }} style={{ paddingLeft: "0", paddingRight: "0" }} />
                        </div>
                        <div className='column is-one-half bb-input-column'>
                            <BbInput label={this.props.translate("Common.To")} name="activity.maxEmployees" type="number" placeholder={{ type: 'inline' }} style={{ paddingLeft: "0", paddingRight: "0" }} />
                        </div>
                    </div>
                </div>
            </div>
        </MarketingSection>);
    }

    setDefaultTurnoverYear(all) {
        if (all.length != 0 && this.props.formik.values.activity.turnoverYears.all.length == 0 ) {
            this.props.formik.setFieldValue('activity.turnoverYears.all', [{ label: this.props.translate('Search.ActivityScope.TurnoverYears.Recent'), value: "rc" }]);
        }
        if (all.length == 0 && this.props.formik.values.activity.turnoverYears.all.length != 0) {
            this.props.formik.setFieldValue('activity.turnoverYears.all', []);
        }
    }

    getValue(value) {
        if (value === null || value === "")
            return "All"
        else return value
    }

    getOptions = () => {
        return (
            [
                { value: "All", label: "Search.ActivityScope.NaceAll" },
                { value: "Rsk", label: 'Search.ActivityScope.NaceResSk' },
                { value: "Ruz", label: 'Search.ActivityScope.NaceRegUz' }
            ]
        )
    }
}

export default withLocalize(connect(state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch))(connectFormik(ActivityScope)));